import './HeaderLanding.css';
import Logo from '../images/logo.png';
import { Link, useNavigate, useLocation } from "react-router-dom";
import React from "react";

const HeaderLanding: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Explicit type annotation for linkStyle
  const linkStyle = (path: string): React.CSSProperties => ({
    color: location.pathname === path ? "#1780FB" : "inherit",
  });

  return (
    <div className="container header-container mt-10">
      <nav className="navbar-container px-4 py-3 mt-30 w-full">
        <div className="navbar-container-inner">
          <Link className="navbar-brand d-flex align-items-center" to="/" style={linkStyle("/")}>
            <img src={Logo} alt="Ease Margin" className="me-2 h-6" />
          </Link>

          <ul className="navbar-items navbar-nav flex-row mx-auto gap-2 text-sm">
            <li className="nav-item">
              <Link className="nav-link active" to="/" >Home</Link>
              <div className="nav-link-border active"></div>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us" style={linkStyle("/about-us")}>About</Link>
              <div className="nav-link-border"></div>
            </li>
           <li className="nav-item">
  <a
    href="#pricing-section"
    className="nav-link"
    style={linkStyle("/pricing")}
    onClick={(e) => {
      e.preventDefault(); // Prevent navigation
      const section = document.getElementById("pricing-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }}
  >
    Pricing
  </a>
  <div className="nav-link-border"></div>
</li>

            <li className="nav-item">
              <Link className="nav-link" to="/payment-invoice" style={linkStyle("/payment-invoice")}>Free Invoicing</Link>
              <div className="nav-link-border"></div>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/our-blogs" style={linkStyle("/our-blogs")}>Blog</Link>
              <div className="nav-link-border"></div>
            </li>
          </ul>
        </div>

        <div className="navbar-container-btn">
          <button
            className="navbar-login-btn text-sm"
            onClick={() => navigate("/sign-in")}
          >
            Sign Up
          </button>
          <button
            className="navbar-demo-btn text-sm"
            onClick={() => navigate("/requestdemo")}
          >
            Request a Demo
          </button>
        </div>
      </nav>
    </div>
  );
};

export default HeaderLanding;
